'use strict';

var effects = require('redux-saga/effects');

/* This file is generated. Do not edit it. */
function* call(...args) {
  return yield effects.call(...args);
}

function deferredAction(saga, io) {
  return function* withCatch(action) {
    const {
      stdout
    } = io;
    try {
      const result = yield effects.call(saga, io, action);
      yield effects.call(action.meta.deferred.success, result);
    } catch (err) {
      yield effects.call(stdout, `${saga.name}`, err);
      yield effects.call(action.meta.deferred.failure, err);
    }
  };
}
function typedDeferredAction(saga, io) {
  return function* withCatch(action) {
    const {
      stdout
    } = io;
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const result = yield* call(saga, io, action);
      yield* call(action.meta.deferred.success, result);
    } catch (err) {
      yield* call(stdout, `${saga.name}`, err);
      yield* call(action.meta.deferred.failure, err);
    }
  };
}

function standardAction(saga, io) {
  return function* withCatch(action) {
    const {
      stdout
    } = io;
    try {
      yield effects.call(saga, io, action);
    } catch (err) {
      yield effects.call(stdout, `${saga.name}`, err);
    }
  };
}
function typedStandardAction(saga, io) {
  return function* withCatch(action) {
    const {
      stdout
    } = io;
    try {
      yield* call(saga, io, action);
    } catch (err) {
      yield* call(stdout, `${saga.name}`, err);
    }
  };
}

exports.deferredAction = deferredAction;
exports.standardAction = standardAction;
exports.typedDeferredAction = typedDeferredAction;
exports.typedStandardAction = typedStandardAction;
